import ServiceTable from './ServiceTable';
export default ServiceTable;